import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import { getRegistration } from "redux/actions/UserRegistration";
import CommonForm from "components/commonForm/CommonForm";
import { registrationForm } from "./formdata";
import logo from "assets/images/companyLogo.svg";

export default function Signup() {
  const navigate = useNavigate();
  const dispatch = useDispatch(); 


  const handleredirect = () => {
    navigate("/login");
  };




  const onSignup = (data, code) => {
    const signupPayload = {
      userDetails: {
        platform: 'CustomerApp',
        mobile: data.number,
        email: data.email,
        countryCode: data.country,
        gender:data.gender,
        firstName: data.firstname,
        lastName:data.lastName,
        },
    actionType: "signup"
  }
    localStorage.setItem("registered", true);
    dispatch(getRegistration(signupPayload, navigate));
  };

  return (
    <div>
      <Box sm={{ flexGrow: 1 }} className="signupMobileRes">
        <Grid container>
          <Grid item sm={6}>
            <Box
              sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center" }}
              className="positionAbsolute"
            >
              <img src={logo} className="logoImg" alt="otplogo" />
            </Box>
            {/* ---login input type--- */}
            <div className={"signuploginInput signupMobileBg"}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
              >
                <Grid item sm={10} className="textCenter">
                  <Typography className="fontBold font36 colorBlue">
                    Start Your Journey
                  </Typography>
                  <Typography className="signupFontStyle colorYellow">Sign Up Today</Typography>
                </Grid>
                <Grid item sm={7}>
                  <CommonForm
                    formData={registrationForm}
                    button={"Sign Up"}
                    onSubmittBtn={onSignup}
                  />
                </Grid>
              </Grid>
              <Typography className="colorGrey font18 fontNormal marginTop">
                Already have an account ?
                <span className="colorBlue cursor" onClick={handleredirect}>
                 &nbsp;Login now
                </span>
              </Typography>
            </div>
          </Grid>
          <Grid
            item
            sm={6}
            sx={{ display: { xs: "none", sm: "flex" } }}
            className="bgImage"
          >
            <div className={"signupBgImg"}></div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
